import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';

import { query } from '../../GraphQL/query/MyProfile.query';

import { MyProfileButton } from '../../Components/MenuItem/AuthButton';

const profileConverter = (myProfile = {}) => ({
  firstname: myProfile.userDetails && myProfile.userDetails.firstName,
});

export default class MyProfileButtonGQL extends Component {
  static propTypes = {};

  render() {
    return (
      <Query query={query}>
        {({ loading, error, data, client }) => {
          const myProfile = profileConverter((data && data.myProfile) || {});
          return (
            <MyProfileButton
              {...this.props}
              myProfile={myProfile}
              logout={() => {
                client.resetStore();
                this.props.logout();
              }}
            />
          );
        }}
      </Query>
    );
  }
}
